import { Component } from '@angular/core';
import { BaseComponent } from '@shared/components/base-component/base.component';

@Component({
  selector: 'app-b2c-redirect-page',
  templateUrl: './b2c-redirect-page.component.html',
  styleUrls: ['./b2c-redirect-page.component.scss']
})
export class B2cRedirectPageComponent extends BaseComponent  {
  constructor(){
    super()
  }
openB2CPortal(type:string){
  window.open('https://lastmile.madar.app/',type );
}
}
